module.exports = __webpack_public_path__ + "img/payramax.02e72879.svg";